// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table_tableWrapper__bhe0Y","tableHeader":"Table_tableHeader__BfE9d","tableCell":"Table_tableCell__ycTHf","empty":"Table_empty__4ulVO"};